import script from "./DataChangesLogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataChangesLogs.vue?vue&type=script&lang=ts&setup=true"

import "./DataChangesLogs.vue?vue&type=style&index=0&id=29549e20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29549e20"]])

export default __exports__